import { ModalHeader, ModalBody } from 'baseui/modal';
import { StatefulSelect, TYPE, StyledDropdownListItem } from 'baseui/select';
import { StyledList } from 'baseui/menu';
import { Tag } from 'baseui/tag';
import extend from 'lodash/extend';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import toLower from 'lodash/toLower';
import { v4 } from 'uuid';
import { withStyle } from 'styletron-react';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import List from 'react-virtualized/dist/commonjs/List';
import * as React from 'react';
import type { ElementRefT } from '../../types';
import type { QnAStateType, QuestionType } from '../../reducers';
import { getModalState, getQuestionsAsOptions } from '../../reducers/selectors';
import Modal from './Modal';
const ListItem = withStyle(StyledDropdownListItem, {
  paddingTop: 0,
  paddingBottom: 0,
  display: 'flex',
  alignItems: 'center'
});
const Container = withStyle(StyledList, {
  height: '200px'
});
type VirtualListT = {
  $ref: ElementRefT;
  role: string;
  children: React.ReactNode[];
};
const VirtualList = ({
  $ref,
  role,
  children
}: VirtualListT) => {
  return (
    // @ts-expect-error todo(ts-migration) TS2322 Type '{ children: Element; $ref: ElementRefT; }' is not assignable to type 'IntrinsicAttributes & { $as?: "ul"; } & StyledProps & { $style?: StyleObject | ((props: StyledProps) => StyleObject); classN...
    <Container $ref={$ref}>
      <AutoSizer>
        {({
          width
        }) => <List role={role} height={200} width={width} rowCount={children.length || 0} rowHeight={36} rowRenderer={({
          index,
          key,
          style
        }) => {
          const itemProps = get(children, `${index}.props`);
          const item = get(itemProps, `item`);
          return <ListItem key={key} style={style} {...itemProps}>
                  {item.question}{' '}
                  {item.tags.map((tag, idx) => <Tag key={idx} hierarchy="secondary" closeable={false}>
                      {tag}
                    </Tag>)}
                </ListItem>;
        }} />}
      </AutoSizer>
    </Container>
  );
};
type PropsT = {
  state: QnAStateType;
  setModal: Function;
  addQuestion: Function;
};
type StateT = {
  selectedQuestions: Array<QuestionType>;
};
export default class ModalCopyQuestion extends React.PureComponent<PropsT, StateT> {
  constructor(props: PropsT, context: any) {
    super(props, context);
    this.state = {
      selectedQuestions: []
    };
  }
  render() {
    const type = 'copy';
    const {
      state,
      setModal,
      addQuestion
    } = this.props;
    const modalState = getModalState(state, type);
    const questionLists = getQuestionsAsOptions(state);
    return <Modal type={type} modalState={modalState} setModal={setModal} onConfirm={modalState => {
      // user selected to copy
      const {
        selectedQuestions
      } = this.state;

      // copyig selected questions
      if (!isEmpty(selectedQuestions)) {
        const {
          questionId: targetQuestionId
        } = modalState;
        selectedQuestions.forEach(question => {
          const newQuestion = extend({}, question, {
            id: v4(),
            followUps: []
          });
          addQuestion(targetQuestionId, newQuestion);
        });
      }
    }}>
        <ModalHeader>Select a question to copy</ModalHeader>
        <ModalBody>
          <p>Search by question, tags, and uuid</p>
          <StatefulSelect type={TYPE.search} labelKey="question" valueKey="id" options={questionLists} maxDropdownHeight="200px" placeholder="Start searching" overrides={{
          Dropdown: {
            component: VirtualList
          }
        }} onChange={({
          type,
          option
        }) => {
          switch (type) {
            case 'select':
            // @ts-expect-error todo(ts-migration) TS2678 Type '"unselect"' is not comparable to type '"clear" | "select" | "remove"'.
            case 'unselect':
              this.setState({
                // baseui only guaruntees that the option is an OptionT (does not satisfy QuestionType)
                // fix would require type-validating here, before updating state
                // @ts-expect-error todo(ts-migration) TS2740 Type 'Readonly<{ [x: string]: any; id?: string | number; label?: ReactNode; disabled?: boolean; clearableValue?: boolean; isCreatable?: boolean; __optgroup?: string; }>' is missing the following prope...
                selectedQuestions: [option]
              });
              break;
          }
        }} filterOptions={(options, query: string) => {
          const qr = toLower(query);
          const nextOptions = options.filter(option => {
            if (toLower(option.question).includes(qr)) {
              return true;
            }
            if (toLower(option.tags.join('  ')).includes(qr)) {
              return true;
            }
            return false;
          });
          return nextOptions || [];
        }} />
        </ModalBody>
      </Modal>;
  }
}